import { CookieSettings } from './interfaces/CookieSettings';
import { CookieDataTypes } from './CookieDataTypes';

export const DEFAULT_COOKIE_SETTINGS: CookieSettings = {
   [CookieDataTypes.STRICTLY_NECESSARY]: true,
   [CookieDataTypes.FUNCTIONAL]: false,
   [CookieDataTypes.DIAGNOSTIC]: false,
   [CookieDataTypes.USAGE]: false,
};
